import { LOGIN_PATH } from './authConfig';
import { AuthRouteNames } from './authRoutes';
/**
 * Old reset links still exist: the new-user sign-up email (UserService, "set your password"), emails sent before the switch, maybe MGMT.
 * They look like /change-password?resetToken=<base64 of Identity's reset token, '=' written as '-'>&userId=N.
 * V2 takes Identity's token as it is, so the extra base64 layer comes off here. Null when the link is incomplete or garbled.
 */
export function legacyResetToV2(query) {
    const userId = query.userId;
    const resetToken = query.resetToken;
    if (typeof userId !== 'string' || !/^\d+$/.test(userId) || typeof resetToken !== 'string' || !resetToken)
        return null;
    // a raw '+' may arrive as a space from the query parser; the old '-' was only ever the padding
    const base64 = resetToken.replace(/ /g, '+').replace(/-/g, '=');
    try {
        const bytes = Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));
        return { uid: userId, token: new TextDecoder().decode(bytes) };
    }
    catch {
        return null;
    }
}
/** Where an old /change-password link goes while V2 is on: the V2 reset screen, or the login when the link is incomplete */
export function legacyResetRoute(query) {
    const link = legacyResetToV2(query);
    return link ? { name: AuthRouteNames.ResetPassword, query: link } : { path: LOGIN_PATH, query: {} };
}
